import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Button } from '@mobiscroll/react-latest'
import { IOrgObj } from '../../../types'
import Edit from '../../icons/organizations/Edit'
import ImageView from '../../ui/ImageView'
import timezones from '../../../constants/Timezones'
import timeformats from '../../../constants/Timeformats'
import sendEmails from '../../../constants/SendEmailOptions'
import UIMessages from '../../../utils/ui-messages'
import BackToList from 'src/components/ui/BackToList'
import { handleRedirect } from 'src/utils'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import FormLabel from 'src/components/ui/form/FormLabel'
interface IViewOrgProps extends RouteComponentProps<any> {
  getSingleOrganization: (id: string) => void
  error: string
  fetching: boolean
  organization: IOrgObj
}

class ViewOrg extends React.Component<any> {
  constructor(props: IViewOrgProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.getSingleOrganization(this.props.match.params.id)
  }

  public render() {
    const { organization = {}, fetching } = this.props
    const timezone = organization.timeZone ? timezones.find(i => i.value === parseInt(organization.timeZone, 10)) : null
    const timeformat = timeformats.find(i => i.value === organization.timeFormat)
    const sendEmailOption = sendEmails.find(i => i.value === organization.sendEmail)
    const timezoneText = timezone ? timezone.label : ''
    const timeformatText = timeformat ? timeformat.label : ''
    const sendEmailOptionText = sendEmailOption ? sendEmailOption.label : ''
    return (
      <div>
        <div className='col-12'>
          <div className='bb-light-grey4 flex justify-between items-center pr2 py2'>
            <BackToList link='/organizations' className='' />
            <div className='relative flex items-center pl2'>
              <Button
                ariaLabel='Back button'
                className='mbsc-btn-with-start-icon mbsc-success-btn'
                onClick={() => handleRedirect(`/organizations/${organization.id}/edit/organization-info`)}
              >
                {UIMessages.common.edit}
              </Button>
              <Edit className='absolute icon--small ml2 svg-fill-white-path z1' />
            </div>
          </div>
        </div>
        <div className='org-details-container'>
          <FloatingForm>
            <div className='mbsc-grid' style={{ padding: 0 }}>
              <div className='mbsc-row'>
                <div className='mbsc-col-12 mbsc-col-lg-8'>
                  <p className='font-grey3 bold'>{UIMessages.common.organizationInfo}</p>
                  <div className='bb-shadow-grey' />
                  <div className='mbsc-row'>
                    <div className='mbsc-col-12 mbsc-padding'>
                      <FormLabel>{UIMessages.common.nameLabel}</FormLabel>
                      <div className='column-gap-16 flex items-center mt1'>
                        <ImageView entityId={organization.id} />
                        <div className='h5'>{organization.name}</div>
                      </div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.common.email}</FormLabel>
                      <div className='mt1 h5'>{organization.email || 'None'}</div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.common.phoneNumber}</FormLabel>
                      <div className='mt1 h5'>{organization.phone || 'None'}</div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.organization.organizationInfo.callerID}</FormLabel>
                      <div className='mt1 h5'>{organization.callerID || 'None'}</div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.organization.organizationInfo.timeZone}</FormLabel>
                      <div className='mt1 h5'>{timezoneText}</div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.organization.organizationInfo.timeFormat}</FormLabel>
                      <div className='mt1 h5'>{timeformatText}</div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.common.website}</FormLabel>
                      <div className='mt1 h5'>{organization.website || 'None'}</div>
                    </div>
                    <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                      <FormLabel>{UIMessages.common.description}</FormLabel>
                      <div className='mt1 h5'>{organization.description || 'None'}</div>
                    </div>
                  </div>
                </div>
                <div className='mbsc-col-12 mbsc-col-lg-4'>
                  <p className='font-grey3 bold'>{UIMessages.common.organizationSetting}</p>
                  <div className='bb-shadow-grey' />
                  <div className='mbsc-row'>
                    <div className='mbsc-col-12 mbsc-padding'>
                      <FormLabel>{UIMessages.organization.organizationInfo.sendEmail}</FormLabel>
                      <div className='mt1 h5'>{sendEmailOptionText}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FloatingForm>
        </div>
      </div>
    )
  }
}

export default ViewOrg



// WEBPACK FOOTER //
// ./src/components/organizations/view/ViewOrg.tsx